import React from 'react';
import {Link} from 'react-router-dom';
import SocialBlock from './SocialBlock';
import styles from './Footer.scss';

const FooterSmall = () => {
  return (
    <div className={"d-flex justify-content-between " + styles.smallFooter}>
      <div className={styles.footerLinks}>
        <a href="/" className='smText'>Home</a>
        <a href="/contact-us" className="smText" rel="nofollow">Contact us</a>
        <a href="https://www.cotality.com/au/legal/privacy" target="_blank" rel="nofollow noopener noreferrer" className='smText'>
          Privacy policy
        </a>
        <Link to='/terms-of-use' className='smText'>Terms of use</Link>
        <a href="https://www.cotality.com/au/legal/disclaimers" target="_blank" rel="nofollow noopener noreferrer" className='smText'>
          Disclaimers
        </a>
      </div>
      <div className="d-flex align-items-center"><SocialBlock /></div>
    </div>
  );
};

export default FooterSmall;
